const CryptoJS = require("crypto-js")

export const useCryptoEncrypter = () => {

    const encrypt = (src: string, value: string) => {
        return value;
        var encrypto = CryptoJS.AES.encrypt(value, src);
        return encrypto.toString();
    };

    const decrypt = (src: string, value: any) => {
        return value;
        let decryptedId = CryptoJS.AES.decrypt(value, src);
        return decryptedId.toString(CryptoJS.enc.Utf8);
    };


    return {
        encrypt,
        decrypt,
    }

}